import { render, staticRenderFns } from "./VoipManager.vue?vue&type=template&id=5a7b0106&scoped=true"
import script from "./VoipManager.vue?vue&type=script&lang=js"
export * from "./VoipManager.vue?vue&type=script&lang=js"
import style0 from "./VoipManager.vue?vue&type=style&index=0&id=5a7b0106&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a7b0106",
  null
  
)

export default component.exports